import React, { useState } from 'react';
import { X } from 'lucide-react';
import PlanQuestionnaire from './plan/PlanQuestionnaire';
import GeneratedPlan from './plan/GeneratedPlan';
import { questions } from './plan/questions';
import type { PlanAnswers } from './plan/types';

interface TailoredPlanModalProps {
  onClose: () => void;
}

export default function TailoredPlanModal({ onClose }: TailoredPlanModalProps) {
  const [answers, setAnswers] = useState<PlanAnswers>({
    objective: '',
    contentType: '',
    bestPerforming: '',
    targetAudience: ''
  });
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedPlan, setGeneratedPlan] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsGenerating(true);
    
    // Simulate API call to generate plan
    await new Promise(resolve => setTimeout(resolve, 2000));
    
    setGeneratedPlan(true);
    setIsGenerating(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl max-w-4xl w-full mx-4 max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white p-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-xl font-semibold text-gray-900">
            {generatedPlan ? 'Seu Plano Personalizado' : 'Criar Plano Personalizado'}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="p-6">
          {!generatedPlan ? (
            <PlanQuestionnaire
              questions={questions}
              answers={answers}
              setAnswers={setAnswers}
              onSubmit={handleSubmit}
              isGenerating={isGenerating}
            />
          ) : (
            <GeneratedPlan 
              answers={answers}
              onClose={onClose}
            />
          )}
        </div>
      </div>
    </div>
  );
}